import { useCallback } from "react";
import { useLocaleStore, type Locale } from "./stores/locale-store";

type Params = Record<string, string | number>;

const thMessages: Record<string, string> = {
  "Dashboard": "แดชบอร์ด",
  "Ebook Studio": "สตูดิโออีบุ๊ก",
  "Ebooks": "อีบุ๊ก",
  "เพิ่มอีบุ๊ก": "เพิ่มอีบุ๊ก",
  "Settings": "ตั้งค่า",
  "Profile": "โปรไฟล์",
  "English": "อังกฤษ",
  "View profile": "ดูโปรไฟล์",
  "Sign out": "ออกจากระบบ",
  "เปลี่ยนภาษาเป็น English": "เปลี่ยนภาษาเป็นอังกฤษ",
  "Draft": "ฉบับร่าง",
  "Uploading": "กำลังอัปโหลด",
  "Queued": "รอประมวลผล",
  "Processing": "กำลังประมวลผล",
  "Ready": "พร้อมใช้งาน",
  "Failed": "ล้มเหลว",
  "Publishing": "กำลังเผยแพร่",
  "Published": "เผยแพร่แล้ว",
  "Ebooks ทั้งหมด": "อีบุ๊กทั้งหมด",
  "เพิ่ม E-book เล่มแรกจากเมนู Ebooks": "เพิ่มอีบุ๊กเล่มแรกจากเมนูอีบุ๊ก",
  "Add Ebook": "เพิ่มอีบุ๊ก",
  "ไม่พบรายการ E-book": "ไม่พบรายการอีบุ๊ก",
  "สร้าง E-book ไม่สำเร็จ": "สร้างอีบุ๊กไม่สำเร็จ",
  "Title Ebook": "ชื่ออีบุ๊ก",
  "ตั้งชื่อ": "ตั้งชื่อ",
  "แนบไฟล์ PDF": "แนบไฟล์ PDF",
  "ประมวลผล": "ประมวลผล",
  "E-book พร้อมใช้งานแล้ว": "อีบุ๊กพร้อมใช้งานแล้ว",
  "การประมวลผล PDF ไม่สำเร็จ": "ประมวลผล PDF ไม่สำเร็จ",
  "กำลังลองใหม่…": "กำลังลองใหม่…",
  "กำลังประมวลผล PDF": "กำลังประมวลผล PDF",
  "{{processed}} / {{total}} หน้า ({{progress}}%)": "{{processed}} / {{total}} หน้า ({{progress}}%)",
  "ปิดหน้าต่างนี้ได้ การประมวลผลจะดำเนินต่อในพื้นหลัง": "ปิดหน้าต่างนี้ได้ การประมวลผลจะดำเนินต่อในพื้นหลัง",
  "ถัดไป": "ถัดไป",
  "ย้อนกลับ": "ย้อนกลับ",
  "กำลังสร้างและอัปโหลด…": "กำลังสร้างและอัปโหลด…",
  "สร้าง Ebook และอัปโหลด PDF": "สร้างอีบุ๊กและอัปโหลด PDF",
  "ไปที่ Ebook": "ไปที่อีบุ๊ก",
  "Email": "อีเมล",
  "Upload PDF": "อัปโหลด PDF",
  "รองรับ PDF สูงสุด 250 MB และ 3,000 หน้า": "รองรับ PDF สูงสุด 250 MB และ 3,000 หน้า",
  "AUTO OCR SCAN": "AUTO OCR SCAN",
  "Skip": "ข้าม",
  "ลากไฟล์ PDF มาวางที่นี่": "ลากไฟล์ PDF มาวางที่นี่",
  "เลือกไฟล์ PDF": "เลือกไฟล์ PDF",
  "กำลัง Upload {{progress}}%": "กำลังอัปโหลด {{progress}}%",
  "เริ่ม Upload": "เริ่มอัปโหลด",
  "Upload ไม่สำเร็จ": "อัปโหลดไม่สำเร็จ",
  "Professional publishing": "การเผยแพร่มืออาชีพ",
  "ระบบสร้าง E-Magazine": "ระบบสร้างนิตยสารออนไลน์",
  "Sign in with Google": "เข้าสู่ระบบด้วย Google",
  "PDF to E-Magazine": "แปลง PDF เป็นนิตยสารออนไลน์",
  "Secure access powered by Google": "เข้าสู่ระบบปลอดภัยด้วย Google",
  "Google Sign-In failed to load": "โหลด Google Sign-In ไม่สำเร็จ",
  "การใช้งาน Ebook Studio ใช้สำหรับสร้าง จัดการ และเผยแพร่ E-book จากไฟล์ PDF ที่คุณมีสิทธิ์ใช้งานเท่านั้น": "การใช้งานสตูดิโออีบุ๊กใช้สำหรับสร้าง จัดการ และเผยแพร่อีบุ๊กจากไฟล์ PDF ที่คุณมีสิทธิ์ใช้งานเท่านั้น",
  "ระบบอาจประมวลผลไฟล์และข้อความเพื่อสร้างภาพหน้า สารบัญ ค้นหา และตรวจทานด้วย AI เฉพาะเมื่อคุณสั่งใช้งานฟีเจอร์ที่เกี่ยวข้อง": "ระบบอาจประมวลผลไฟล์และข้อความเพื่อสร้างภาพหน้า สารบัญ ข้อมูลค้นหา และตรวจทานด้วย AI เฉพาะเมื่อคุณสั่งใช้งานฟีเจอร์ที่เกี่ยวข้อง",
  "บัญชีของคุณใช้ Google Sign-In เพื่อยืนยันตัวตน และข้อมูลบัญชีพื้นฐานจะถูกใช้เพื่อรักษาความปลอดภัยและแสดงผลในระบบ": "บัญชีของคุณใช้การเข้าสู่ระบบด้วย Google เพื่อยืนยันตัวตน และข้อมูลบัญชีพื้นฐานจะถูกใช้เพื่อรักษาความปลอดภัยและแสดงผลในระบบ",
  "ไม่พบ Ebook ID ใน Preview URL": "ไม่พบรหัสอีบุ๊กใน URL ดูตัวอย่าง",
  "E-book ต้องประมวลผลเสร็จแล้วจึงจะ Preview ได้": "อีบุ๊กต้องประมวลผลเสร็จแล้วจึงจะดูตัวอย่างได้",
  "เปิด Preview ไม่สำเร็จ": "เปิดหน้าดูตัวอย่างไม่สำเร็จ",
  "กำลังโหลด Preview": "กำลังโหลดหน้าดูตัวอย่าง",
  "ปิด Preview": "ปิดหน้าดูตัวอย่าง",
  "กำลังเปิด E-book": "กำลังเปิดอีบุ๊ก",
  "กำลังเปิด {{title}}": "กำลังเปิด {{title}}",
  "Preview {{title}}": "ดูตัวอย่าง {{title}}",
  "Preview": "ดูตัวอย่าง",
  "โหลด E-book ไม่สำเร็จ": "โหลดอีบุ๊กไม่สำเร็จ",
  "บันทึก Project name ไม่สำเร็จ": "บันทึกชื่อโปรเจกต์ไม่สำเร็จ",
  "Upload รูปภาพไม่สำเร็จ": "อัปโหลดรูปภาพไม่สำเร็จ",
  "โหลดสิทธิ์การใช้งานไม่สำเร็จ": "โหลดสิทธิ์การใช้งานไม่สำเร็จ",
  "ล้างรูปภาพไม่สำเร็จ": "ล้างรูปภาพไม่สำเร็จ",
  "Download ไม่สำเร็จ": "ดาวน์โหลดไม่สำเร็จ",
  "ไม่พบ E-book": "ไม่พบอีบุ๊ก",
  "กรุณาเลือกไฟล์ PDF": "กรุณาเลือกไฟล์ PDF",
  "ไฟล์ต้องมีขนาดไม่เกิน 250 MB": "ไฟล์ต้องมีขนาดไม่เกิน 250 MB",
  "ยกเลิกการ Upload แล้ว": "ยกเลิกการอัปโหลดแล้ว",
  "Publish ไม่สำเร็จ": "เผยแพร่ไม่สำเร็จ",
  "ต้องกรอก Project name ก่อน": "ต้องกรอกชื่อโปรเจกต์ก่อน",
  "ระบบจะสร้าง PDF หน้า Under construction ก่อนเผยแพร่": "ระบบจะสร้าง PDF หน้า Under construction ก่อนเผยแพร่",
  "ระบบจะสร้าง PDF หน้า Under construction แล้วเผยแพร่เมื่อประมวลผลเสร็จ": "ระบบจะสร้าง PDF หน้า Under construction แล้วเผยแพร่เมื่อประมวลผลเสร็จ",
  "Download": "ดาวน์โหลด",
  "Favicon": "ไอคอนเว็บ",
  "Logo": "โลโก้",
  "Favicon preview": "ตัวอย่างไอคอนเว็บ",
  "Logo preview": "ตัวอย่างโลโก้",
  "OpenAI API key": "คีย์ API ของ OpenAI",
  "Model": "โมเดล",
  "Content": "เนื้อหา",
  "Branding": "แบรนด์",
  "Admin": "แอดมิน",
  "Payment": "ชำระเงิน",
  "Reader toolbar": "แถบเครื่องมือผู้อ่าน",
  "Publish": "เผยแพร่",
  "Title": "ชื่อเรื่อง",
  "รายละเอียดอีบุ๊ก": "รายละเอียดอีบุ๊ก",
  "ใช้เป็น Meta description เมื่อ Preview, Download หรือ Publish": "ใช้เป็น Meta description เมื่อดูตัวอย่าง ดาวน์โหลด หรือเผยแพร่",
  "Copyright": "ลิขสิทธิ์",
  "แสดงเป็นข้อความเล็กในหน้า Reader ถ้าเว้นว่างจะไม่แสดง": "แสดงเป็นข้อความเล็กในหน้า Reader ถ้าเว้นว่างจะไม่แสดง",
  "การแสดงผลหน้า": "การแสดงผลหน้า",
  "หน้าเดี่ยว": "หน้าเดี่ยว",
  "หน้าคู่": "หน้าคู่",
  "ใช้กับ Preview, ZIP และเว็บไซต์ที่ Publish": "ใช้กับดูตัวอย่าง ZIP และเว็บไซต์ที่เผยแพร่",
  "ภาพปก": "ภาพปก",
  "ตัวอย่างภาพปก": "ตัวอย่างภาพปก",
  "อัปโหลดภาพปก": "อัปโหลดภาพปก",
  "ใช้เป็น Meta image · PNG, JPG หรือ WebP สูงสุด 8 MB": "ใช้เป็น Meta image · PNG, JPG หรือ WebP สูงสุด 8 MB",
  "ไม่มีรายการ": "ไม่มีรายการ",
  "ยังไม่มีรายการ Payment ตามตัวกรองนี้": "ยังไม่มีรายการชำระเงินตามตัวกรองนี้",
  "ส่วนจัดการ E-book": "ส่วนจัดการอีบุ๊ก",
  "Project name": "ชื่อโปรเจกต์",
  "Project name ถูกล็อกถาวรหลัง Publish แล้ว": "ชื่อโปรเจกต์ถูกล็อกถาวรหลังเผยแพร่แล้ว",
  "ไม่สามารถแก้ Project name ระหว่างกำลัง Publish": "ไม่สามารถแก้ชื่อโปรเจกต์ระหว่างกำลังเผยแพร่",
  "URL จะเป็น https://ebook.appstartup.co.th/ebook/{{project}}": "URL จะเป็น https://ebook.appstartup.co.th/ebook/{{project}}",
  "ใช้ตัวอักษร a-z ตัวเลข 0-9 และเครื่องหมาย -": "ใช้ตัวอักษร a-z ตัวเลข 0-9 และเครื่องหมาย -",
  "บันทึก Project name": "บันทึกชื่อโปรเจกต์",
  "Retry publish": "เผยแพร่อีกครั้ง",
  "เปิด published URL": "เปิด URL ที่เผยแพร่แล้ว",
  "Public Asset URL": "Public Asset URL",
  "Cloudflare Pages URL": "Cloudflare Pages URL",
  "สแกนหรือเปิด URL ผ่าน Asset Worker": "สแกนหรือเปิด URL ผ่าน Asset Worker",
  "สแกนหรือเปิด URL จาก Cloudflare Pages": "สแกนหรือเปิด URL จาก Cloudflare Pages",
  "เปิด URL": "เปิด URL",
  "คัดลอก URL": "คัดลอก URL",
  "คัดลอกแล้ว": "คัดลอกแล้ว",
  "สร้าง QR code ไม่สำเร็จ": "สร้าง QR code ไม่สำเร็จ",
  "สร้าง QR Code ใหม่": "สร้าง QR Code ใหม่",
  "กำลังสร้าง QR Code ใหม่": "กำลังสร้าง QR Code ใหม่",
  "QR code สำหรับ public URL": "QR code สำหรับ URL สาธารณะ",
  "QR code สำหรับ {{title}}": "QR code สำหรับ {{title}}",
  "สแกนเพื่อเปิดเว็บไซต์ที่เผยแพร่แล้ว": "สแกนเพื่อเปิดเว็บไซต์ที่เผยแพร่แล้ว",
  "พื้นที่สื่อรวม": "พื้นที่สื่อรวม",
  "พื้นที่จัดเก็บ": "พื้นที่จัดเก็บ",
  "พื้นที่สื่อที่ระบบติดตามสำหรับ E-book นี้": "พื้นที่สื่อที่ระบบติดตามสำหรับอีบุ๊กนี้",
  "ยังไม่มีข้อมูลพื้นที่จัดเก็บ": "ยังไม่มีข้อมูลพื้นที่จัดเก็บ",
  "{{count}} รายการ": "{{count}} รายการ",
  "PDF ต้นฉบับ": "PDF ต้นฉบับ",
  "รูปหน้า E-book": "รูปหน้าอีบุ๊ก",
  "รูปตัวอย่างหน้า": "รูปตัวอย่างหน้า",
  "ไอคอนเว็บ": "ไอคอนเว็บ",
  "โลโก้": "โลโก้",
  "รูปพื้นหลัง": "รูปพื้นหลัง",
  "PDF ที่เผยแพร่แล้ว": "PDF ที่เผยแพร่แล้ว",
  "Branding และพื้นหลัง": "แบรนด์และพื้นหลัง",
  "Background image ไม่บังคับ หากอัปโหลด ระบบ reader จะแสดงภาพแบบเต็มหน้าจอด้วย cover": "รูปพื้นหลังไม่บังคับ หากอัปโหลด ระบบผู้อ่านจะแสดงภาพเต็มหน้าจอแบบครอบคลุมพื้นที่",
  "Upload favicon": "อัปโหลดไอคอนเว็บ",
  "Upload logo": "อัปโหลดโลโก้",
  "Background image": "รูปพื้นหลัง",
  "Background preview": "ตัวอย่างพื้นหลัง",
  "Upload background": "อัปโหลดพื้นหลัง",
  "ล้าง": "ล้าง",
  "กำลังล้าง...": "กำลังล้าง...",
  "กำลังล้าง {{kind}}...": "กำลังล้าง {{kind}}...",
  "Background color": "สีพื้นหลัง",
  "Google Font": "ฟอนต์ Google",
  "กำลัง upload {{kind}}...": "กำลังอัปโหลด {{kind}}...",
  "บันทึก Branding": "บันทึกแบรนด์",
  "Retry": "ลองใหม่",
  "แนะนำจาก PDF/OCR": "แนะนำจาก PDF/OCR",
  "ยังไม่พบหัวข้อจาก PDF หรือ OCR สามารถเพิ่มสารบัญเองได้": "ยังไม่พบหัวข้อจาก PDF หรือ OCR สามารถเพิ่มสารบัญเองได้",
  "Content ยังไม่พร้อม": "เนื้อหายังไม่พร้อม",
  "ลบ E-book": "ลบอีบุ๊ก",
  "ลบ E-book?": "ลบอีบุ๊ก?",
  "แสดงปุ่มดาวน์โหลด PDF": "แสดงปุ่มดาวน์โหลด PDF",
  "ค้นหาจากข้อความที่ extract หรือแก้ไขไว้": "ค้นหาจากข้อความที่ดึงหรือแก้ไขไว้",
  "แสดง Pagination": "แสดงเลขหน้า",
  "แสดง Zoom": "แสดงการย่อขยาย",
  "แสดง Fullscreen": "แสดงปุ่มเต็มจอ",
  "เลือกเครื่องมือที่ผู้อ่านจะเห็นใน Preview, ZIP และเว็บไซต์ที่ Publish": "เลือกเครื่องมือที่ผู้อ่านจะเห็นในหน้าดูตัวอย่าง ไฟล์ ZIP และเว็บไซต์ที่เผยแพร่",
  "PDF Bookmark": "บุ๊กมาร์ก PDF",
  "ระบบใช้ PDF Bookmark ก่อน และใช้ข้อความ PDF/OCR เพื่อเสนอหัวข้อเมื่อไม่พบ Bookmark": "ระบบใช้บุ๊กมาร์ก PDF ก่อน และใช้ข้อความจาก PDF/OCR เพื่อเสนอหัวข้อเมื่อไม่พบบุ๊กมาร์ก",
  "PDF text": "ข้อความจาก PDF",
  "กำลังดาวน์โหลดไฟล์ PDF": "กำลังดาวน์โหลดไฟล์ PDF",
  "กำลัง OCR หน้า {{processed}} จาก {{total}}": "กำลัง OCR หน้า {{processed}} จาก {{total}}",
  "กำลังอ่าน Text Layer จาก PDF": "กำลังอ่านชั้นข้อความจาก PDF",
  "ดึงข้อมูลจาก PDF สำเร็จ": "ดึงข้อมูลจาก PDF สำเร็จ",
  "เริ่มดึงข้อมูลจาก PDF ไม่สำเร็จ": "เริ่มดึงข้อมูลจาก PDF ไม่สำเร็จ",
  "เริ่มตรวจทานด้วย AI ไม่สำเร็จ": "เริ่มตรวจทานด้วย AI ไม่สำเร็จ",
  "นำคำแนะนำจาก AI ไปใช้ไม่สำเร็จ": "นำคำแนะนำจาก AI ไปใช้ไม่สำเร็จ",
  "ดึงข้อมูลจากไฟล์ PDF": "ดึงข้อมูลจากไฟล์ PDF",
  "ตรวจทานด้วย AI": "ตรวจทานด้วย AI",
  "ดึงข้อมูลจาก PDF ไม่สำเร็จ: {{reason}}": "ดึงข้อมูลจาก PDF ไม่สำเร็จ: {{reason}}",
  "ความคืบหน้าการดึงข้อมูลจาก PDF": "ความคืบหน้าการดึงข้อมูลจาก PDF",
  "ตรวจทานด้วย AI ไม่สำเร็จ: {{reason}}": "ตรวจทานด้วย AI ไม่สำเร็จ: {{reason}}",
  "พบ {{count}} หน้า": "พบ {{count}} หน้า",
  "หน้า {{page}}": "หน้า {{page}}",
  "คุณภาพ {{score}}/100": "คุณภาพ {{score}}/100",
  "ตรวจ OCR แล้ว": "ตรวจ OCR แล้ว",
  "ควรตรวจ {{count}} คำ": "ควรตรวจ {{count}} คำ",
  "ข้อความจาก PDF": "ข้อความจาก PDF",
  "คืนค่าจาก PDF": "คืนค่าจาก PDF",
  "คำจาก OCR ที่ระบบแนะนำให้ตรวจ: {{items}}": "คำจาก OCR ที่ระบบแนะนำให้ตรวจ: {{items}}",
  "ข้อความจาก PDF ยาวเกินขีดจำกัดและถูกตัดบางส่วน": "ข้อความจาก PDF ยาวเกินขีดจำกัดและถูกตัดบางส่วน",
  "คำแนะนำจาก AI": "คำแนะนำจาก AI",
  "AI ตรวจทานข้อความหน้านี้แล้ว": "AI ตรวจทานข้อความหน้านี้แล้ว",
  "ข้อความที่ AI แนะนำ": "ข้อความที่ AI แนะนำ",
  "ข้อความสำหรับค้นหาของหน้า {{page}}": "ข้อความสำหรับค้นหาของหน้า {{page}}",
  "ข้อความของหน้าที่เลือกจะถูกส่งไปยัง OpenAI เพื่อสร้างคำแนะนำ แยกจากข้อความปัจจุบัน ระบบจะไม่เขียนทับข้อมูลจนกว่าคุณจะตรวจสอบและกด “นำคำแนะนำไปใช้” การใช้งานมีค่าใช้จ่ายตาม OpenAI API key ที่ตั้งไว้": "ข้อความของหน้าที่เลือกจะถูกส่งไปยัง OpenAI เพื่อสร้างคำแนะนำ แยกจากข้อความปัจจุบัน ระบบจะไม่เขียนทับข้อมูลจนกว่าคุณจะตรวจสอบและกด “นำคำแนะนำไปใช้” การใช้งานมีค่าใช้จ่ายตามคีย์ API ของ OpenAI ที่ตั้งไว้",
  "ตรวจเฉพาะหน้า {{page}}": "ตรวจเฉพาะหน้า {{page}}",
  "ระบบจะดึงข้อความและสารบัญจากไฟล์ PDF ต้นฉบับอีกครั้ง ข้อมูลข้อความเดิมที่เคยดึงมา รวมถึงข้อความที่แก้ไขเองทุกหน้า จะถูกทับทั้งหมดและไม่สามารถเรียกคืนได้": "ระบบจะดึงข้อความและสารบัญจากไฟล์ PDF ต้นฉบับอีกครั้ง ข้อมูลข้อความเดิมที่เคยดึงมา รวมถึงข้อความที่แก้ไขเองทุกหน้า จะถูกทับทั้งหมดและไม่สามารถเรียกคืนได้",
  "ข้อความถูกแก้ไขจากหน้าต่างอื่น ระบบโหลด revision ล่าสุดแล้วและเก็บข้อความที่คุณพิมพ์ไว้": "ข้อความถูกแก้ไขจากหน้าต่างอื่น ระบบโหลดเวอร์ชันล่าสุดแล้วและเก็บข้อความที่คุณพิมพ์ไว้",
  "ข้อความถูกแก้ไขจากหน้าต่างอื่น และโหลด revision ล่าสุดไม่สำเร็จ": "ข้อความถูกแก้ไขจากหน้าต่างอื่น และโหลดเวอร์ชันล่าสุดไม่สำเร็จ",
  "กำลังรอระบบประมวลผลรับงาน หากสถานะนี้ไม่เปลี่ยนภายในประมาณ 30 วินาที ให้ตรวจสอบว่า converter service กำลังทำงานอยู่": "กำลังรอระบบประมวลผลรับงาน หากสถานะนี้ไม่เปลี่ยนภายในประมาณ 30 วินาที ให้ตรวจสอบว่าบริการแปลงไฟล์กำลังทำงานอยู่",
  "ตรวจคุณภาพทุกหน้า และใช้ OCR เฉพาะหน้าที่ Text Layer ว่างหรือคะแนนต่ำ": "ตรวจคุณภาพทุกหน้า และใช้ OCR เฉพาะหน้าที่ชั้นข้อความว่างหรือคะแนนต่ำ",
  "AI กำลังตรวจทาน…": "AI กำลังตรวจทาน…",
  "กำลังรอ AI reviewer รับงาน": "กำลังรอระบบตรวจทาน AI รับงาน",
  "AI กำลังตรวจทานด้วย {{model}}": "AI กำลังตรวจทานด้วย {{model}}",
  "AI กำลังตรวจทานและบันทึกอัตโนมัติด้วย {{model}}": "AI กำลังตรวจทานและบันทึกอัตโนมัติด้วย {{model}}",
  "ระบบกำลังตรวจหลายหน้าและบันทึกผลที่ผ่านเงื่อนไขให้อัตโนมัติ": "ระบบกำลังตรวจหลายหน้าและบันทึกผลที่ผ่านเงื่อนไขให้อัตโนมัติ",
  "ระบบจะส่งข้อความตามช่วงหน้าที่เลือกไปยัง OpenAI เพื่อตรวจทานและบันทึกผลอัตโนมัติ โดยไม่แต่งเนื้อหาใหม่": "ระบบจะส่งข้อความตามช่วงหน้าที่เลือกไปยัง OpenAI เพื่อตรวจทานและบันทึกผลอัตโนมัติ โดยไม่แต่งเนื้อหาใหม่",
  "ช่วงหน้าที่ต้องการตรวจ": "ช่วงหน้าที่ต้องการตรวจ",
  "เฉพาะหน้า": "เฉพาะหน้า",
  "หน้าคะแนนต่ำ": "หน้าคะแนนต่ำ",
  "ทุกหน้าที่ยังไม่ได้รับการแก้ไขด้วย AI": "ทุกหน้าที่ยังไม่ได้รับการแก้ไขด้วย AI",
  "ทุกหน้าที่ยังไม่มีการแก้ไข": "ทุกหน้าที่ยังไม่มีการแก้ไข",
  "ทุกหน้า": "ทุกหน้า",
  "เลขหน้า": "เลขหน้า",
  "คั่นหลายหน้าด้วย comma เช่น 1, 3, 8": "คั่นหลายหน้าด้วย comma เช่น 1, 3, 8",
  "เริ่มตรวจและบันทึกอัตโนมัติ": "เริ่มตรวจและบันทึกอัตโนมัติ",
  "ดูรายละเอียดคำแนะนำจาก AI": "ดูรายละเอียดคำแนะนำจาก AI",
  "รายละเอียดคำแนะนำจาก AI": "รายละเอียดคำแนะนำจาก AI",
  "ผลตรวจทานถูกบันทึกอัตโนมัติแล้ว": "ผลตรวจทานถูกบันทึกอัตโนมัติแล้ว",
  "ผลตรวจทานยังไม่ถูกบันทึก เพราะข้อความหน้านี้เปลี่ยนระหว่างตรวจ": "ผลตรวจทานยังไม่ถูกบันทึก เพราะข้อความหน้านี้เปลี่ยนระหว่างตรวจ",
  "สรุป": "สรุป",
  "ข้อความที่ AI ตรวจทานแล้ว": "ข้อความที่ AI ตรวจทานแล้ว",
  "ปิด": "ปิด",
  "API key จะถูกเข้ารหัสและใช้งานผ่าน backend เท่านั้น": "คีย์ API จะถูกเข้ารหัสและใช้งานผ่านระบบหลังบ้านเท่านั้น",
  "ลบ OpenAI API key แล้ว": "ลบคีย์ API ของ OpenAI แล้ว",
  "เชื่อมต่อ OpenAI สำเร็จ ({{model}})": "เชื่อมต่อ OpenAI สำเร็จ ({{model}})",
  "ทดสอบ OpenAI ไม่สำเร็จ": "ทดสอบ OpenAI ไม่สำเร็จ",
  "AI ตรวจทานข้อความ": "AI ตรวจทานข้อความ",
  "สถานะ: ตั้งค่าแล้ว {{hint}}": "สถานะ: ตั้งค่าแล้ว {{hint}}",
  "บันทึกแล้ว {{hint}} — กรอกใหม่เมื่อต้องการเปลี่ยน": "บันทึกแล้ว {{hint}} — กรอกใหม่เมื่อต้องการเปลี่ยน",
  "ลบ API key": "ลบคีย์ API",
  "ลองเปลี่ยนตัวกรองหรือเพิ่ม E-book ใหม่": "ลองเปลี่ยนตัวกรองหรือเพิ่มอีบุ๊กใหม่",
  "โหลด Dashboard ไม่สำเร็จ": "โหลดแดชบอร์ดไม่สำเร็จ",
  "ยังไม่มี E-book": "ยังไม่มีอีบุ๊ก",
  "{{count}} หน้า": "{{count}} หน้า",
  "{{count}} หน้า พร้อมใช้งาน": "{{count}} หน้า พร้อมใช้งาน",
  "PDF สูงสุด 250 MB และ 3,000 หน้า": "PDF สูงสุด 250 MB และ 3,000 หน้า",
  "เปลี่ยน PDF": "เปลี่ยน PDF",
  "สถานะ: {{status}}": "สถานะ: {{status}}",
  "PNG หรือ ICO สูงสุด 2 MB": "PNG หรือ ICO สูงสุด 2 MB",
  "PNG, JPG หรือ WebP สูงสุด 5 MB": "PNG, JPG หรือ WebP สูงสุด 5 MB",
  "PNG, JPG หรือ WebP สูงสุด 15 MB": "PNG, JPG หรือ WebP สูงสุด 15 MB",
  "กำลังสร้าง ZIP...": "กำลังสร้าง ZIP...",
  "การประมวลผล PDF": "การประมวลผล PDF",
  "อัปโหลดและรอประมวลผล PDF ให้เสร็จก่อนจัดการข้อความ": "อัปโหลดและรอประมวลผล PDF ให้เสร็จก่อนจัดการข้อความ",
  "อัปโหลดและรอประมวลผล PDF ให้เสร็จก่อนจัดการสารบัญ": "อัปโหลดและรอประมวลผล PDF ให้เสร็จก่อนจัดการสารบัญ",
};

const enMessages: Record<string, string> = {
  "Dashboard": "Dashboard",
  "Ebook Studio": "Ebook Studio",
  "Ebooks": "Ebooks",
  "เพิ่มอีบุ๊ก": "Add ebook",
  "Settings": "Settings",
  "Profile": "Profile",
  "English": "English",
  "View profile": "View profile",
  "Sign out": "Sign out",
  "เปิดเมนู": "Open menu",
  "เมนูโปรไฟล์": "Profile menu",
  "สลับเป็นโหมดสว่าง": "Switch to light mode",
  "สลับเป็นโหมดมืด": "Switch to dark mode",
  "เปลี่ยนภาษาเป็น English": "Switch language to English",
  "เปลี่ยนภาษาเป็นไทย": "Switch language to Thai",
  "เปลี่ยนภาษาไม่สำเร็จ": "Could not change language",
  "ลองใหม่": "Try again",
  "Draft": "Draft",
  "Uploading": "Uploading",
  "Queued": "Queued",
  "Processing": "Processing",
  "Ready": "Ready",
  "Failed": "Failed",
  "Publishing": "Publishing",
  "Published": "Published",
  "Ebooks ทั้งหมด": "Total ebooks",
  "พร้อมใช้งาน": "Ready",
  "กำลังประมวลผล": "Processing",
  "มีปัญหา": "Issues",
  "โหลด Dashboard ไม่สำเร็จ": "Could not load dashboard",
  "ยังไม่มี E-book": "No e-books yet",
  "เพิ่ม E-book เล่มแรกจากเมนู Ebooks": "Add your first e-book from the Ebooks menu",
  "{{count}} หน้า": "{{count}} pages",
  "Add Ebook": "Add Ebook",
  "โหลดรายการไม่สำเร็จ": "Could not load the list",
  "ค้นหาชื่อ": "Search by title",
  "สถานะ": "Status",
  "ทั้งหมด": "All",
  "สถานะ: {{status}}": "Status: {{status}}",
  "ไม่พบรายการ E-book": "No e-books found",
  "ลองเปลี่ยนตัวกรองหรือเพิ่ม E-book ใหม่": "Try changing filters or adding a new e-book",
  "สร้าง E-book ไม่สำเร็จ": "Could not create e-book",
  "Title Ebook": "E-book title",
  "ตั้งชื่อ": "ตั้งชื่อ",
  "แนบไฟล์ PDF": "แนบไฟล์ PDF",
  "ประมวลผล": "ประมวลผล",
  "E-book พร้อมใช้งานแล้ว": "E-book is ready",
  "การประมวลผล PDF ไม่สำเร็จ": "ประมวลผล PDF ไม่สำเร็จ",
  "กำลังลองใหม่…": "กำลังลองใหม่…",
  "กำลังประมวลผล PDF": "กำลังประมวลผล PDF",
  "{{processed}} / {{total}} หน้า ({{progress}}%)": "{{processed}} / {{total}} หน้า ({{progress}}%)",
  "ปิดหน้าต่างนี้ได้ การประมวลผลจะดำเนินต่อในพื้นหลัง": "ปิดหน้าต่างนี้ได้ การประมวลผลจะดำเนินต่อในพื้นหลัง",
  "ถัดไป": "ถัดไป",
  "ย้อนกลับ": "ย้อนกลับ",
  "กำลังสร้างและอัปโหลด…": "กำลังสร้างและอัปโหลด…",
  "สร้าง Ebook และอัปโหลด PDF": "Create e-book and upload PDF",
  "ไปที่ Ebook": "Go to e-book",
  "ยกเลิก": "Cancel",
  "บันทึกและเพิ่ม PDF": "Save and add PDF",
  "บันทึกแล้ว": "Saved",
  "ชื่อที่แสดง": "Display name",
  "Email": "Email",
  "บันทึก": "Save",
  "Upload PDF": "Upload PDF",
  "กรุณาเลือกไฟล์ PDF เท่านั้น": "Please choose a PDF file only",
  "ไฟล์ต้องมีขนาดไม่เกิน 250 MB": "File size must not exceed 250 MB",
  "Upload ไม่สำเร็จ": "Upload failed",
  "รองรับ PDF สูงสุด 250 MB และ 3,000 หน้า": "Supports PDFs up to 250 MB and 3,000 pages",
  "AUTO OCR SCAN": "AUTO OCR SCAN",
  "Skip": "Skip",
  "เปลี่ยนไฟล์": "Change file",
  "ลากไฟล์ PDF มาวางที่นี่": "Drag a PDF file here",
  "หรือ": "or",
  "เลือกไฟล์ PDF": "Choose PDF file",
  "กำลัง Upload {{progress}}%": "Uploading {{progress}}%",
  "เริ่ม Upload": "Start upload",
  "ทั่วไป": "General",
  "ภาษาและธีมของแอป": "App language and theme",
  "ภาษา": "Language",
  "ไทย": "Thai",
  "ธีม": "Theme",
  "ตามระบบ": "System",
  "สว่าง": "Light",
  "มืด": "Dark",
  "AI ตรวจทานข้อความ": "AI proofreading",
  "API key จะถูกเข้ารหัสและใช้งานผ่าน backend เท่านั้น": "The API key is encrypted and used only through the backend",
  "แนะนำ — คุณภาพดีและประหยัดสำหรับตรวจข้อความ": "Recommended — good quality and cost-efficient for proofreading",
  "เร็ว เหมาะกับเอกสารจำนวนมาก": "Fast, suitable for large document batches",
  "คุณภาพสูงขึ้น เหมาะกับข้อความที่แก้ยาก": "Higher quality, suitable for difficult text",
  "ประหยัดที่สุด เหมาะกับการแก้คำทั่วไป": "Lowest cost, suitable for general corrections",
  "บันทึกแล้ว {{hint}} — กรอกใหม่เมื่อต้องการเปลี่ยน": "Saved {{hint}} — enter a new key to change it",
  "สถานะ: ตั้งค่าแล้ว {{hint}}": "Status: configured {{hint}}",
  "ยังไม่ได้ตั้งค่า": "Not configured",
  "ลบ API key": "Remove API key",
  "กำลังทดสอบ…": "Testing…",
  "ทดสอบการเชื่อมต่อ": "Test connection",
  "กำลังบันทึก…": "Saving…",
  "กำลังบันทึก...": "Saving...",
  "ลบ OpenAI API key แล้ว": "OpenAI API key removed",
  "บันทึกการตั้งค่าแล้ว": "Settings saved",
  "โหลดการตั้งค่าไม่สำเร็จ": "Could not load settings",
  "บันทึกการตั้งค่าไม่สำเร็จ": "Could not save settings",
  "เชื่อมต่อ OpenAI สำเร็จ ({{model}})": "OpenAI connected successfully ({{model}})",
  "ทดสอบ OpenAI ไม่สำเร็จ": "OpenAI test failed",
  "Professional publishing": "Professional publishing",
  "ระบบสร้าง E-Magazine": "E-Magazine creation system",
  "กำลังเข้าสู่ระบบ": "Signing in",
  "Sign in with Google": "Sign in with Google",
  "PDF to E-Magazine": "PDF to E-Magazine",
  "Secure access powered by Google": "Secure access powered by Google",
  "ยอมรับเงื่อนไขและข้อตกลงในการใช้บริการ": "Accept the terms and conditions of service",
  "ฉันยอมรับ": "I accept",
  "เงื่อนไขและข้อตกลงในการใช้บริการ": "Terms and conditions of service",
  "กรุณายอมรับเงื่อนไขก่อนเข้าสู่ระบบ": "Please accept the terms before signing in",
  "การใช้งาน Ebook Studio ใช้สำหรับสร้าง จัดการ และเผยแพร่ E-book จากไฟล์ PDF ที่คุณมีสิทธิ์ใช้งานเท่านั้น": "Ebook Studio is intended for creating, managing, and publishing e-books from PDF files that you have the right to use.",
  "คุณรับรองว่าไฟล์ ข้อความ รูปภาพ และข้อมูลที่อัปโหลดไม่ละเมิดกฎหมาย ลิขสิทธิ์ เครื่องหมายการค้า หรือสิทธิของบุคคลอื่น": "You confirm that uploaded files, text, images, and data do not violate laws, copyrights, trademarks, or the rights of others.",
  "ระบบอาจประมวลผลไฟล์และข้อความเพื่อสร้างภาพหน้า สารบัญ ค้นหา และตรวจทานด้วย AI เฉพาะเมื่อคุณสั่งใช้งานฟีเจอร์ที่เกี่ยวข้อง": "The system may process files and text to generate page images, tables of contents, search data, and AI proofreading only when you use the related features.",
  "บัญชีของคุณใช้ Google Sign-In เพื่อยืนยันตัวตน และข้อมูลบัญชีพื้นฐานจะถูกใช้เพื่อรักษาความปลอดภัยและแสดงผลในระบบ": "Your account uses Google Sign-In for authentication, and basic account information is used for security and display inside the system.",
  "บริการนี้ให้ใช้งานตามสภาพจริง ผู้ใช้ต้องตรวจสอบความถูกต้องของเนื้อหาและผลลัพธ์ก่อนนำไปเผยแพร่": "This service is provided as-is. Users must verify content and output before publishing.",
  "ปิด": "Close",
  "ยอมรับ": "Accept",
  "Google Sign-In failed to load": "Google Sign-In failed to load",
  "ไม่พบ Ebook ID ใน Preview URL": "Missing ebook ID in preview URL",
  "E-book ต้องประมวลผลเสร็จแล้วจึงจะ Preview ได้": "The e-book must finish processing before preview",
  "เปิด Preview ไม่สำเร็จ": "Could not open preview",
  "กำลังโหลด Preview": "Loading preview",
  "ปิด Preview": "Close preview",
  "กำลังเปิด E-book": "Opening e-book",
  "กำลังเปิด {{title}}": "Opening {{title}}",
  "Preview {{title}}": "Preview {{title}}",
  "Preview": "Preview",
  "โหลด E-book ไม่สำเร็จ": "Could not load e-book",
  "บันทึกไม่สำเร็จ": "Could not save",
  "บันทึก Project name ไม่สำเร็จ": "Could not save project name",
  "Upload รูปภาพไม่สำเร็จ": "Image upload failed",
  "โหลดสิทธิ์การใช้งานไม่สำเร็จ": "Could not load entitlement",
  "ล้างรูปภาพไม่สำเร็จ": "Image clear failed",
  "Download ไม่สำเร็จ": "Download failed",
  "ไม่พบ E-book": "E-book not found",
  "กรุณาเลือกไฟล์ PDF": "Please choose a PDF file",
  "ยกเลิกการ Upload แล้ว": "Upload cancelled",
  "Publish ไม่สำเร็จ": "Publish failed",
  "ต้องกรอก Project name ก่อน": "Enter a project name before publishing",
  "ระบบจะสร้าง PDF หน้า Under construction ก่อนเผยแพร่": "A one-page Under construction PDF will be created before publishing",
  "ระบบจะสร้าง PDF หน้า Under construction แล้วเผยแพร่เมื่อประมวลผลเสร็จ": "A one-page Under construction PDF will be created and published after processing finishes",
  "แก้ไขข้อมูลและจัดการไฟล์ต้นฉบับ": "Edit details and manage source files",
  "กำลังสร้าง ZIP...": "Creating ZIP...",
  "Download": "Download",
  "Favicon": "Favicon",
  "Logo": "Logo",
  "Favicon preview": "Favicon preview",
  "Logo preview": "Logo preview",
  "OpenAI API key": "OpenAI API key",
  "Model": "Model",
  "ส่วนจัดการ E-book": "E-book management sections",
  "ข้อมูลทั่วไป": "General",
  "Content": "Content",
  "สารบัญ": "Table of contents",
  "Branding": "Branding",
  "Admin": "Admin",
  "Payment": "Payment",
  "Reader toolbar": "Reader toolbar",
  "Publish": "Publish",
  "รายละเอียด": "Details",
  "Title": "Title",
  "รายละเอียดอีบุ๊ก": "E-book description",
  "ใช้เป็น Meta description เมื่อ Preview, Download หรือ Publish": "Used as the meta description in preview, download, and published builds",
  "Copyright": "Copyright",
  "แสดงเป็นข้อความเล็กในหน้า Reader ถ้าเว้นว่างจะไม่แสดง": "Shown as small text in the Reader. Leave blank to hide it.",
  "การแสดงผลหน้า": "Page display",
  "หน้าเดี่ยว": "Single page",
  "หน้าคู่": "Double page",
  "ใช้กับ Preview, ZIP และเว็บไซต์ที่ Publish": "Applies to Preview, ZIP, and published sites",
  "ภาพปก": "Cover image",
  "ตัวอย่างภาพปก": "Cover image preview",
  "อัปโหลดภาพปก": "Upload cover image",
  "ใช้เป็น Meta image · PNG, JPG หรือ WebP สูงสุด 8 MB": "Used as the meta image · PNG, JPG, or WebP up to 8 MB",
  "ไม่มีรายการ": "No items",
  "ยังไม่มีรายการ Payment ตามตัวกรองนี้": "There are no payment items for this filter",
  "ไฟล์ต้นฉบับ": "Source file",
  "{{count}} หน้า พร้อมใช้งาน": "{{count}} pages ready",
  "PDF สูงสุด 250 MB และ 3,000 หน้า": "PDF up to 250 MB and 3,000 pages",
  "เปลี่ยน PDF": "Replace PDF",
  "ลบ E-book": "Delete e-book",
  "การเผยแพร่": "Publication",
  "Project name": "Project name",
  "Project name ถูกล็อกถาวรหลัง Publish แล้ว": "Project name is permanently locked after publishing",
  "ไม่สามารถแก้ Project name ระหว่างกำลัง Publish": "Project name cannot be changed while publishing",
  "URL จะเป็น https://ebook.appstartup.co.th/ebook/{{project}}": "URL will be https://ebook.appstartup.co.th/ebook/{{project}}",
  "ใช้ตัวอักษร a-z ตัวเลข 0-9 และเครื่องหมาย -": "Use a-z, 0-9, and hyphens",
  "บันทึก Project name": "Save project name",
  "Retry publish": "Retry publish",
  "เปิด published URL": "Open published URL",
  "Public Asset URL": "Public Asset URL",
  "Cloudflare Pages URL": "Cloudflare Pages URL",
  "สแกนหรือเปิด URL ผ่าน Asset Worker": "Scan or open the Asset Worker URL",
  "สแกนหรือเปิด URL จาก Cloudflare Pages": "Scan or open the Cloudflare Pages URL",
  "เปิด URL": "Open URL",
  "คัดลอก URL": "Copy URL",
  "คัดลอกแล้ว": "Copied",
  "สร้าง QR code ไม่สำเร็จ": "Could not generate QR code",
  "สร้าง QR Code ใหม่": "Regenerate QR Code",
  "กำลังสร้าง QR Code ใหม่": "Regenerating QR Code",
  "QR code สำหรับ public URL": "QR code for public URL",
  "QR code สำหรับ {{title}}": "QR code for {{title}}",
  "สแกนเพื่อเปิดเว็บไซต์ที่เผยแพร่แล้ว": "Scan to open the published website",
  "พื้นที่สื่อรวม": "Total media storage",
  "พื้นที่จัดเก็บ": "Storage",
  "พื้นที่สื่อที่ระบบติดตามสำหรับ E-book นี้": "Tracked media storage for this e-book",
  "ยังไม่มีข้อมูลพื้นที่จัดเก็บ": "No storage data yet",
  "{{count}} รายการ": "{{count}} items",
  "PDF ต้นฉบับ": "Original PDF",
  "รูปหน้า E-book": "E-book page images",
  "รูปตัวอย่างหน้า": "Page thumbnails",
  "ไอคอนเว็บ": "Favicon",
  "โลโก้": "Logo",
  "รูปพื้นหลัง": "Background image",
  "PDF ที่เผยแพร่แล้ว": "Published PDF",
  "Branding และพื้นหลัง": "Branding and background",
  "Background image ไม่บังคับ หากอัปโหลด ระบบ reader จะแสดงภาพแบบเต็มหน้าจอด้วย cover": "Background image is optional. If uploaded, the reader shows it fullscreen with cover sizing.",
  "ไม่มี": "None",
  "Upload favicon": "Upload favicon",
  "PNG หรือ ICO สูงสุด 2 MB": "PNG or ICO up to 2 MB",
  "Upload logo": "Upload logo",
  "PNG, JPG หรือ WebP สูงสุด 5 MB": "PNG, JPG, or WebP up to 5 MB",
  "Background image": "Background image",
  "Background preview": "Background preview",
  "Upload background": "Upload background",
  "ล้าง": "Clear",
  "กำลังล้าง...": "Clearing...",
  "กำลังล้าง {{kind}}...": "Clearing {{kind}}...",
  "PNG, JPG หรือ WebP สูงสุด 15 MB": "PNG, JPG, or WebP up to 15 MB",
  "รูปแบบตัวอักษรและสี": "Typography and color",
  "Background color": "Background color",
  "Google Font": "Google Font",
  "กำลัง upload {{kind}}...": "Uploading {{kind}}...",
  "บันทึก Branding": "Save branding",
  "การประมวลผล PDF": "PDF processing",
  "Retry": "Retry",
  "Content ยังไม่พร้อม": "Content is not ready",
  "อัปโหลดและรอประมวลผล PDF ให้เสร็จก่อนจัดการข้อความ": "Upload and wait for PDF processing to finish before managing text",
  "สารบัญยังไม่พร้อม": "Table of contents is not ready",
  "อัปโหลดและรอประมวลผล PDF ให้เสร็จก่อนจัดการสารบัญ": "Upload and wait for PDF processing to finish before managing the table of contents",
  "ลบ E-book?": "Delete e-book?",
  "รายการจะถูกซ่อนทันที และไฟล์จะถูกลบถาวรหลัง 7 วัน": "The item will be hidden immediately, and files will be permanently deleted after 7 days",
  "ลบ": "Delete",
  "แสดงเมนู": "Show menu",
  "สารบัญจาก PDF และภาพย่อทุกหน้า": "PDF table of contents and page thumbnails",
  "แสดงการค้นหา": "Show search",
  "ค้นหาจากข้อความที่ extract หรือแก้ไขไว้": "Search extracted or edited text",
  "แสดงปุ่มดาวน์โหลด PDF": "Show PDF download button",
  "ซ่อนเฉพาะปุ่ม ไม่เปลี่ยนสิทธิ์เข้าถึงไฟล์": "Only hides the button. File access permissions are unchanged.",
  "แสดง Pagination": "Show pagination",
  "ปุ่มก่อนหน้า เลขหน้า และปุ่มถัดไป": "Previous button, page number, and next button",
  "แสดง Zoom": "Show zoom",
  "ย่อและขยายหน้าหนังสือ 50–200%": "Zoom pages from 50–200%",
  "แสดง Fullscreen": "Show fullscreen",
  "เปิด Reader เต็มหน้าจอเมื่อ browser รองรับ": "Open the reader fullscreen when supported by the browser",
  "เลือกเครื่องมือที่ผู้อ่านจะเห็นใน Preview, ZIP และเว็บไซต์ที่ Publish": "Choose the tools readers will see in preview, ZIP, and published sites",
  "โหลดสารบัญไม่สำเร็จ": "Could not load table of contents",
  "สารบัญถูกแก้ไขจากหน้าต่างอื่น ระบบจะโหลดข้อมูลล่าสุด": "The table of contents was edited in another window. The latest data will be loaded.",
  "บันทึกสารบัญไม่สำเร็จ": "Could not save table of contents",
  "คืนค่าสารบัญไม่สำเร็จ": "Could not reset table of contents",
  "แก้ไขเอง": "Edited manually",
  "PDF Bookmark": "PDF bookmark",
  "แนะนำจาก PDF/OCR": "Suggested from PDF/OCR",
  "จัดการสารบัญ": "Manage table of contents",
  "ระบบใช้ PDF Bookmark ก่อน และใช้ข้อความ PDF/OCR เพื่อเสนอหัวข้อเมื่อไม่พบ Bookmark": "The system uses PDF bookmarks first, then PDF/OCR text to suggest headings when no bookmarks are found.",
  "คืนค่าที่ตรวจพบ": "Reset to detected",
  "บันทึกสารบัญ": "Save table of contents",
  "รายการนี้เป็นข้อเสนอจากข้อความที่ระบบอ่านได้ กรุณาตรวจชื่อหัวข้อและเลขหน้าก่อนบันทึก": "These items are suggestions from readable text. Check titles and page numbers before saving.",
  "ชื่อหัวข้อ": "Heading title",
  "หน้า": "Page",
  "หน้า {{page}}": "Page {{page}}",
  "เลื่อนขึ้น": "Move up",
  "เลื่อนลง": "Move down",
  "ลดระดับ": "Outdent",
  "ทำเป็นหัวข้อย่อย": "Make subheading",
  "ลบหัวข้อนี้และหัวข้อย่อย": "Delete this heading and subheadings",
  "ยังไม่พบหัวข้อจาก PDF หรือ OCR สามารถเพิ่มสารบัญเองได้": "No headings were found from PDF or OCR. You can add the table of contents manually.",
  "เพิ่มหัวข้อ": "Add heading",
  "กำลังดาวน์โหลดไฟล์ PDF": "Downloading PDF file",
  "กำลังอ่าน Text Layer จาก PDF": "Reading PDF text layer",
  "กำลัง OCR หน้า {{processed}} จาก {{total}}": "OCR page {{processed}} of {{total}}",
  "กำลังสร้างสารบัญ": "Creating table of contents",
  "กำลังบันทึกข้อความและสารบัญ": "Saving text and table of contents",
  "ดึงข้อมูลจาก PDF สำเร็จ": "PDF content extracted successfully",
  "กำลังรอระบบประมวลผล": "Waiting for processing",
  "โหลดรายการหน้าไม่สำเร็จ": "Could not load pages",
  "โหลดข้อความไม่สำเร็จ": "Could not load text",
  "โหลดสถานะการดึงข้อมูลไม่สำเร็จ": "Could not load extraction status",
  "ข้อความถูกแก้ไขจากหน้าต่างอื่น ระบบโหลด revision ล่าสุดแล้วและเก็บข้อความที่คุณพิมพ์ไว้": "Text was edited in another window. The latest revision was loaded and your typed text was kept.",
  "ข้อความถูกแก้ไขจากหน้าต่างอื่น และโหลด revision ล่าสุดไม่สำเร็จ": "Text was edited in another window, and the latest revision could not be loaded.",
  "บันทึกข้อความไม่สำเร็จ": "Could not save text",
  "ค้นหาไม่สำเร็จ": "Search failed",
  "เริ่มดึงข้อมูลจาก PDF ไม่สำเร็จ": "Could not start PDF extraction",
  "เริ่มตรวจทานด้วย AI ไม่สำเร็จ": "Could not start AI proofreading",
  "นำคำแนะนำจาก AI ไปใช้ไม่สำเร็จ": "Could not apply AI suggestion",
  "ค้นหาข้อความทุกหน้า": "Search text on every page",
  "กำลังดึงข้อมูล…": "Extracting…",
  "ดึงข้อมูลจากไฟล์ PDF": "Extract content from PDF",
  "AI กำลังตรวจทาน…": "AI is proofreading…",
  "ตรวจทานด้วย AI": "Proofread with AI",
  "ลองอีกครั้ง": "Try again",
  "ดึงข้อมูลจาก PDF ไม่สำเร็จ: {{reason}}": "PDF extraction failed: {{reason}}",
  "ไม่ทราบสาเหตุ": "Unknown reason",
  "กำลังรอระบบประมวลผลรับงาน หากสถานะนี้ไม่เปลี่ยนภายในประมาณ 30 วินาที ให้ตรวจสอบว่า converter service กำลังทำงานอยู่": "Waiting for the processor to pick up the job. If this does not change within about 30 seconds, check that the converter service is running.",
  "ความคืบหน้าการดึงข้อมูลจาก PDF": "PDF extraction progress",
  "ตรวจคุณภาพทุกหน้า และใช้ OCR เฉพาะหน้าที่ Text Layer ว่างหรือคะแนนต่ำ": "Checking every page and using OCR only when the text layer is empty or low quality",
  "กำลังรอ AI reviewer รับงาน": "Waiting for the AI reviewer to pick up the job",
  "AI กำลังตรวจทานด้วย {{model}}": "AI is proofreading with {{model}}",
  "AI กำลังตรวจทานและบันทึกอัตโนมัติด้วย {{model}}": "AI is proofreading and auto-saving with {{model}}",
  "ระบบกำลังตรวจหลายหน้าและบันทึกผลที่ผ่านเงื่อนไขให้อัตโนมัติ": "The system is reviewing multiple pages and automatically saving eligible results.",
  "ตรวจทานด้วย AI ไม่สำเร็จ: {{reason}}": "AI proofreading failed: {{reason}}",
  "พบ {{count}} หน้า": "Found {{count}} pages",
  "ไม่พบหน้า": "No pages found",
  "เลือกหน้า": "Select a page",
  "เลือกภาพหน้าจากรายการเพื่อดูและแก้ไขข้อความ": "Select a page image from the list to view and edit text",
  "PDF text": "PDF text",
  "คุณภาพ {{score}}/100": "Quality {{score}}/100",
  "ตรวจ OCR แล้ว": "OCR checked",
  "จัดสระไทยแล้ว": "Thai marks normalized",
  "ควรตรวจ {{count}} คำ": "Review {{count}} words",
  "ข้อความจาก PDF": "PDF text",
  "แก้ไขแล้ว": "Edited",
  "รอบันทึก…": "Waiting to save…",
  "คืนค่าจาก PDF": "Reset from PDF",
  "คำจาก OCR ที่ระบบแนะนำให้ตรวจ: {{items}}": "OCR words suggested for review: {{items}}",
  "ข้อความจาก PDF ยาวเกินขีดจำกัดและถูกตัดบางส่วน": "PDF text exceeded the limit and was truncated",
  "คำแนะนำจาก AI": "AI suggestion",
  "AI ตรวจทานข้อความหน้านี้แล้ว": "AI has proofread this page",
  "ข้อความที่ AI แนะนำ": "AI suggested text",
  "ระบบจะส่งข้อความตามช่วงหน้าที่เลือกไปยัง OpenAI เพื่อตรวจทานและบันทึกผลอัตโนมัติ โดยไม่แต่งเนื้อหาใหม่": "The selected page range will be sent to OpenAI for proofreading and automatic saving, without creating new content.",
  "ช่วงหน้าที่ต้องการตรวจ": "Review range",
  "เฉพาะหน้า": "Specific pages",
  "หน้าคะแนนต่ำ": "Low-score pages",
  "ทุกหน้าที่ยังไม่ได้รับการแก้ไขด้วย AI": "All pages not yet edited by AI",
  "ทุกหน้าที่ยังไม่มีการแก้ไข": "All unedited pages",
  "ทุกหน้า": "All pages",
  "เลขหน้า": "Page numbers",
  "คั่นหลายหน้าด้วย comma เช่น 1, 3, 8": "Separate pages with commas, for example 1, 3, 8",
  "เริ่มตรวจและบันทึกอัตโนมัติ": "Start review and auto-save",
  "ดูรายละเอียดคำแนะนำจาก AI": "View AI suggestion details",
  "รายละเอียดคำแนะนำจาก AI": "AI suggestion details",
  "ผลตรวจทานถูกบันทึกอัตโนมัติแล้ว": "The proofreading result was saved automatically.",
  "ผลตรวจทานยังไม่ถูกบันทึก เพราะข้อความหน้านี้เปลี่ยนระหว่างตรวจ": "The result was not saved because this page changed during review.",
  "สรุป": "Summary",
  "ข้อความที่ AI ตรวจทานแล้ว": "AI-proofread text",
  "นำไปใช้แล้ว": "Applied",
  "กำลังนำไปใช้…": "Applying…",
  "ข้อความเปลี่ยนแล้ว กรุณาตรวจใหม่": "Text changed. Please review again.",
  "นำคำแนะนำไปใช้": "Apply suggestion",
  "ไม่พบข้อความในหน้านี้ คุณสามารถเพิ่มข้อความสำหรับการค้นหาได้": "No text was found on this page. You can add searchable text.",
  "ข้อความสำหรับค้นหาของหน้า {{page}}": "Search text for page {{page}}",
  "ข้อความของหน้าที่เลือกจะถูกส่งไปยัง OpenAI เพื่อสร้างคำแนะนำ แยกจากข้อความปัจจุบัน ระบบจะไม่เขียนทับข้อมูลจนกว่าคุณจะตรวจสอบและกด “นำคำแนะนำไปใช้” การใช้งานมีค่าใช้จ่ายตาม OpenAI API key ที่ตั้งไว้": "The selected page text will be sent to OpenAI to create a suggestion separate from the current text. The system will not overwrite data until you review it and click “Apply suggestion”. Usage is charged to the configured OpenAI API key.",
  "ตรวจเฉพาะหน้า {{page}}": "Review page {{page}} only",
  "กำลังเริ่ม…": "Starting…",
  "ตรวจทุกหน้าคุณภาพต่ำ": "Review all low-quality pages",
  "ยืนยัน": "Confirm",
  "ระบบจะดึงข้อความและสารบัญจากไฟล์ PDF ต้นฉบับอีกครั้ง ข้อมูลข้อความเดิมที่เคยดึงมา รวมถึงข้อความที่แก้ไขเองทุกหน้า จะถูกทับทั้งหมดและไม่สามารถเรียกคืนได้": "The system will extract text and the table of contents from the original PDF again. Previously extracted text, including manually edited text on every page, will be overwritten and cannot be restored.",
  "ยืนยันและดึงข้อมูล": "Confirm and extract",
  "ข้อมูลพื้นฐาน": "Basic info",
  "โซนอันตราย": "Danger zone",
  "รายการจะถูกซ่อนทันที และไฟล์จะถูกลบถาวรหลัง 7 วัน การกระทำนี้ไม่สามารถย้อนกลับได้": "The item will be hidden immediately, and files will be permanently deleted after 7 days. This action cannot be undone.",
  "พิมพ์รหัสด้านล่างเพื่อยืนยันการลบ": "Type the code below to confirm deletion",
  "กำลังลบ...": "Deleting...",
  "ลบ E-book ไม่สำเร็จ": "Could not delete e-book",
  "แผนราคา": "Pricing",
  "เลือกแผนที่เหมาะกับการสร้าง E-Magazine ของคุณ": "Choose the plan that fits your e-magazine",
  "เลือกแผนเพื่อเริ่มต้นใช้งาน": "Choose a plan to get started",
  "คุณสามารถเปลี่ยนแผนได้ภายหลังจากเมนูด้านบนของแอป": "You can change your plan later from the app header",
  "เลือกแผนไม่สำเร็จ": "Could not select plan",
  "เปลี่ยนแผนไม่สำเร็จ": "Could not change plan",
  "เปลี่ยนแผนการใช้งาน": "Change plan",
  "เลือกแผน": "Choose plan",
  "แนะนำ": "Recommended",
  "จำนวนเล่ม": "Books",
  "หน้า/เล่ม": "Pages per book",
  "ไม่จำกัด": "Unlimited",
  "{{count}} เล่ม": "{{count}} books",
  "เริ่มต้นใช้งาน": "Get started",
  "แผนปัจจุบัน": "Current plan",
  "กำลังเปลี่ยน…": "Switching…",
  "เลือกแผนนี้": "Choose this plan",
  "พรีเมียม": "Premium",
  "เริ่มต้นทดลองใช้งานฟรี": "Start with a free trial",
  "สำหรับผู้เริ่มสร้างสื่อออนไลน์": "For creators just getting started",
  "สำหรับมืออาชีพที่ต้องการผลงานคุณภาพ": "For professionals who want quality output",
  "สำหรับทีมและองค์กรที่กำลังเติบโต": "For growing teams and organizations",
  "สำหรับองค์กรขนาดใหญ่ที่ต้องการความยืดหยุ่นสูงสุด": "For large organizations that need maximum flexibility",
};

export function translate(locale: Locale, key: string, params: Params = {}): string {
  const template = locale === "en" ? enMessages[key] ?? key : thMessages[key] ?? key;
  return template.replace(/\{\{(\w+)\}\}/g, (_match, name: string) =>
    params[name] === undefined ? "" : String(params[name]),
  );
}

export function useTranslate() {
  const locale = useLocaleStore((state) => state.locale);
  return useCallback((key: string, params?: Params) => translate(locale, key, params), [locale]);
}
